export default __webpack_public_path__ + "static/media/info.3c3ab395.svg";